import { defineMessages } from 'react-intl';

export default defineMessages({
    doingRateMessage: {
        id: 'renewal.eu.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    lossesAndViolationTabHeading: {
        id: 'renewal.eu.views.riskAnalysis.lossesAndViolation.Losses & Violations',
        defaultMessage: 'Losses & Violations'
    },
    miscellaneaousReportsTabHeading: {
        id: 'renewal.eu.views.riskAnalysis.miscellaneaousReports.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    creditTabHeading: {
        id: 'renewal.eu.views.riskAnalysis.credit.Credit',
        defaultMessage: 'Credit'
    }
});
